import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { Box, Divider, Icon, Text } from '@sparknz/spark-pattern-library';

const IconContainer = styled(Box)`
  ${({ theme: { spacing } }) => css`
    width: 24px;
    display: flex;
    align-items: center;
    margin-right: ${spacing.s2};
  `}
`;

const BottomSection = styled(Box)`
  flex: 1;
`;

interface ProductGalleryCardDealsProps {
  pricePointCreditDescription?: string;
  promoDealString?: string;
}

const ProductGalleryCardDeals = ({
  pricePointCreditDescription,
  promoDealString,
}: ProductGalleryCardDealsProps) => {
  const {
    palette: { baseColors },
  } = useTheme();

  if (!pricePointCreditDescription && !promoDealString) {
    return null;
  }

  return (
    <>
      <Divider />
      <BottomSection
        alignItems="center"
        pt="s3"
        px="s4"
        pb="s2"
        flexDirection="column"
      >
        {pricePointCreditDescription ? (
          <Box
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
            pb="s2"
          >
            <IconContainer>
              <Icon name="spend_small" />
            </IconContainer>
            <Text variant="bodySMedium">{pricePointCreditDescription}</Text>
          </Box>
        ) : null}
        {promoDealString ? (
          <Box
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
            pb="s2"
          >
            <IconContainer>
              <Icon name="gift" />
            </IconContainer>
            <Text variant="bodySMedium" color={baseColors.mawhero}>
              {promoDealString}
            </Text>
          </Box>
        ) : null}
      </BottomSection>
    </>
  );
};

export default ProductGalleryCardDeals;
